/* eslint-disable no-empty-pattern */
import { StandardProps } from "@/types/types";

export function CardSizeToggle({}: Pick<StandardProps, "configProps">) {
  return null;
}
